import styled from 'styled-components';

export const CitySearchProfileWrapper = styled.div<{ isMobile: boolean }>`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    flex-shrink: 1;
    gap: ${({ isMobile }) => (!isMobile ? `22px` : `10px`)};
    ${({ isMobile }) => isMobile && `margin-bottom:0.3125rem;`}
`;

export const MenuLogoHeaderWrapper = styled.div<{ isMobile: boolean }>`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex-shrink: 1;
    align-items: center;
    gap: ${({ isMobile }) => (!isMobile ? `66px` : `10px`)};
`;

export const Wrapper = styled.div<{
    isMobile: boolean;
    scrollShadow: boolean;
}>`
  padding: ${({ isMobile }) =>
      isMobile ? '15px 20px 10px 20px' : '10px 100px'};
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  height: ${({ isMobile }) => (isMobile ? '3.75rem' : '4.5rem')}
  z-index: 101;
  position: sticky;
  top: 0;
  background: #fff;
  flex-shrink: 1;
  box-shadow: ${({ scrollShadow }) =>
      scrollShadow ? '0 0.5px 10px 2px rgb(0 0 0 / 9%)' : 'none'};
`;
